import type { OauthConsentInfo, OauthGrant } from "@codvero/shared";
import { del, get, post } from "./client.ts";

export const oauthApi = {
  consent: (query: string) => get<OauthConsentInfo>(`/api/oauth/consent?${query}`),
  decide: (input: Record<string, unknown>) => post<{ redirect: string }>("/api/oauth/decision", input),
  grants: () => get<OauthGrant[]>("/api/oauth/grants"),
  revoke: (clientId: string) => del(`/api/oauth/grants/${clientId}`),
  info: () => get<{ mcpUrl: string; issuer: string }>("/api/oauth/info"),
};
